import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import api from '../../api';

const Login = () => {
  console.log('🟢 LOGIN COMPONENT MOUNTED');

  const history = useHistory();
  const [activeTab, setActiveTab] = useState('login');
  const [loginForm, setLoginForm] = useState({
    email: '',
    password: '',
    userType: 'CUSTOMER'
  });
  const [signupForm, setSignupForm] = useState({
    email: '',
    password: '',
    name: '',
    phoneNo: ''
  });
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLoginSubmit = (e) => {
    e.preventDefault();

    if (!loginForm.email || !loginForm.password) {
      setMessage('Please enter both email and password');
      return;
    }

    setLoading(true);
    setMessage('');

    api.post('/users/loginUser', {
      emailId: loginForm.email,
      password: loginForm.password,
      userType: 'CUSTOMER'
    })
      .then(response => {
        if (response.data && response.data.userId) {
          localStorage.setItem('user', JSON.stringify(response.data));
          localStorage.setItem('isLoggedIn', 'true');
          localStorage.setItem('userId', response.data.userId);
          setMessage('Login successful! Redirecting...');

          setTimeout(() => {
            history.push('/');
          }, 1500);
        } else {
          setMessage('Login failed. Invalid response from server.');
        }
      })
      .catch(error => {
        let errorMsg = 'Login failed. ';
        if (error.response?.status === 401) {
          errorMsg = 'Invalid email or password.';
        } else if (error.response?.data) {
          errorMsg = error.response.data.message || errorMsg;
        }
        setMessage(errorMsg);
      })
      .finally(() => setLoading(false));
  };

  const handleSignupSubmit = (e) => {
    e.preventDefault();

    if (!signupForm.email || !signupForm.password || !signupForm.name || !signupForm.phoneNo) {
      setMessage('Please fill all fields');
      return;
    }

    setLoading(true);
    setMessage('');

    const params = new URLSearchParams({
      emailId: signupForm.email,
      password: signupForm.password,
      name: signupForm.name,
      phoneNo: signupForm.phoneNo
    });

    api.post(`/users/addNewUserEmail?${params.toString()}`)
      .then(() => {
        setMessage('Account created successfully! Please login.');
        setActiveTab('login');
        setSignupForm({ email: '', password: '', name: '', phoneNo: '' });
      })
      .catch(() => setMessage('Signup failed.'))
      .finally(() => setLoading(false));
  };

  const handleInputChange = (formType) => (e) => {
    const { name, value } = e.target;
    formType === 'login'
      ? setLoginForm(prev => ({ ...prev, [name]: value }))
      : setSignupForm(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div
      className="container-fluid d-flex justify-content-end align-items-center"
      style={{
        backgroundImage: "url('/assets/images/login.png')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
        width: '100%'
      }}
    >
      {/* Glass Card */}
      <div
        style={{
          width: '100%',
          maxWidth: '420px',
          padding: '2.5rem',
          borderRadius: '16px',
          backgroundColor: 'rgba(255, 255, 255, 0.15)',
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
          border: '1px solid rgba(255, 255, 255, 0.25)',
          boxShadow: '0 20px 25px rgba(0,0,0,0.25)',
          color: '#fff'
        }}
      >
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <h1 style={{ fontSize: '2rem', fontWeight: 700 }}>Divine Depot</h1>
          <p style={{ opacity: 0.9 }}>
            {activeTab === 'login'
              ? 'Welcome back! Please sign in.'
              : 'Create your account'}
          </p>
        </div>

        {/* Tabs */}
        <div style={{
          display: 'flex',
          background: 'rgba(255,255,255,0.2)',
          borderRadius: '10px',
          padding: '4px',
          marginBottom: '1.5rem'
        }}>
          {['login', 'signup'].map(tab => (
            <button
              key={tab}
              onClick={() => { setActiveTab(tab); setMessage(''); }}
              disabled={loading}
              style={{
                flex: 1,
                padding: '0.7rem',
                background: activeTab === tab ? '#ffffff' : 'transparent',
                color: activeTab === tab ? '#000' : '#fff',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: 600
              }}
            >
              {tab === 'login' ? 'Sign In' : 'Sign Up'}
            </button>
          ))}
        </div>

        {/* Message */}
        {message && (
          <div style={{
            background: 'rgba(0,0,0,0.5)',
            padding: '0.75rem',
            borderRadius: '8px',
            marginBottom: '1rem',
            textAlign: 'center',
            fontSize: '0.85rem'
          }}>
            {message}
          </div>
        )}

        {/* Login */}
        {activeTab === 'login' && (
          <form onSubmit={handleLoginSubmit}>
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={loginForm.email}
              onChange={handleInputChange('login')}
              required
              style={inputStyle}
            />
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={loginForm.password}
              onChange={handleInputChange('login')}
              required
              style={inputStyle}
            />

            <button type="submit" disabled={loading} style={primaryBtn}>
              {loading ? 'Signing In...' : 'Sign In'}
            </button>

            <div style={{ textAlign: 'center', marginTop: '1rem' }}>
              <Link to="/forgot-password" style={{ color: '#fff' }}>
                Forgot password?
              </Link>
            </div>
          </form>
        )}

        {/* Signup */}
        {activeTab === 'signup' && (
          <form onSubmit={handleSignupSubmit}>
            <input type="text" name="name" placeholder="Full Name" value={signupForm.name} onChange={handleInputChange('signup')} required style={inputStyle} />
            <input type="email" name="email" placeholder="Email" value={signupForm.email} onChange={handleInputChange('signup')} required style={inputStyle} />
            <input type="tel" name="phoneNo" placeholder="Phone Number" value={signupForm.phoneNo} onChange={handleInputChange('signup')} required style={inputStyle} />
            <input type="password" name="password" placeholder="Password" value={signupForm.password} onChange={handleInputChange('signup')} required style={inputStyle} />

            <button type="submit" disabled={loading} style={successBtn}>
              {loading ? 'Creating Account...' : 'Create Account'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

const inputStyle = {
  width: '100%',
  padding: '0.8rem',
  marginBottom: '0.9rem',
  borderRadius: '8px',
  border: 'none',
  outline: 'none'
};

const primaryBtn = {
  width: '100%',
  padding: '0.9rem',
  background: '#2563eb',
  color: '#fff',
  border: 'none',
  borderRadius: '8px',
  fontWeight: 600
};

const successBtn = {
  ...primaryBtn,
  background: '#10b981'
};

export default Login;
